import React from 'react';

import Cell, { Props as CellProps } from './Cell';

import { Entity, ViewMetadata, ViewRequest } from '../../graphql/generated/graphql';
import { FragmentConfig } from '../types';
import getLink from '../../utils/getLink';
import CountryFlag from '../../components/CountryFlag/CountryFlag';
import styles from './table.module.scss';
interface Props {
  config: FragmentConfig;
  metadata: ViewMetadata[];
  acknowledgedValuesFromConfig?: string[];
  row: Entity;
  entityRequest?: ViewRequest;
  rowNumber?: number;
  iconCode?: string | null;
}

function createTableCells(rowData: any, metaData: ViewMetadata[]): CellProps[] {
  return metaData.map((item: ViewMetadata, idx: number) => {
    return {
      linkTo: item.link,
      type: item.type,
      value: rowData[idx] || '',
    };
  });
}

function mapRowData(rowData: any, metadata: ViewMetadata[]): any {
  return metadata.reduce((output: any, item: ViewMetadata, idx) => {
    return { ...output, [item.measure]: rowData[idx] };
  }, {});
}

export default function Row({ config, row, metadata, entityRequest, rowNumber, iconCode }: Props): JSX.Element {
  const linkableCells = config.visualisations[0].measures.reduce(
    (output: string[], item) => (item.link ? output.concat([item.measureName]) : output),
    [],
  );
  const rowData = JSON.parse(row.dataJson)[0];
  const cells = createTableCells(rowData, metadata);
  const showRowNumber = !!config.visualisations[0].showRowNumber && !!rowNumber;
  const showIcon = !!config.visualisations[0].showIcon;

  return (
    <tr>
      {showRowNumber ? <td aria-hidden className={styles.inlineTableCell}>{`${rowNumber}. `}</td> : null}
      {showIcon ? (
        <td aria-hidden className={styles.inlineTableCellIcon}>
          {!!iconCode ? <CountryFlag isoCode={iconCode as string} /> : <span className="text-meta--small">N/A</span>}
        </td>
      ) : null}
      {cells.map(({ value, linkTo, type }: CellProps, idx: number) => {
        const rowDataAsMap = mapRowData(rowData, metadata);
        const fieldsOnEventDispatch = {
          entityId: row.id,
          fieldClicked: metadata[idx].measure,
          entity: rowDataAsMap,
        };

        const cellActions = {
          actions: config.visualisations[0].measures?.[idx]?.actions,
          fields: fieldsOnEventDispatch,
        };
        return (
          <Cell
            cellActions={cellActions}
            clickable={linkableCells.includes(metadata?.[idx]?.measure)}
            link={getLink(config.visualisations[0].measures?.[idx]?.linkTemplate, {
              ...rowDataAsMap,
              entityId: row.id,
            })}
            key={`${row.id}_${metadata[idx].measure}_${idx}`}
            linkTo={linkTo}
            type={type}
            value={value}
            entityRequest={entityRequest}
            externalLink={
              config.visualisations[0].measures?.[idx]?.showExternalLink ? row?.url || undefined : undefined
            }
          />
        );
      })}
    </tr>
  );
}
